import Login from '../views/Login';

export default function publicRoutes(){
  return [
    {
        path: "/login",
        element: <Login />
    },
  ]
};